import React from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./styles";

interface Props {
  closeDrawer: any;
  heading: string;
}

export default function DrawerHeader({ closeDrawer, heading }: Props) {
  const classes = useStyles();
  return (
    <Grid container direction="row">
      <Grid item xs={12} md={12}>
        <Box className={classes.swipeableDrawer}>
          <Grid container direction="row">
            <Grid item xs={12} md={10}>
              <Box ml={0} mt={1} color="text.secondary">
                <Typography component="span" variant="h6" color="textPrimary">
                  {heading}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={2}>
              <Box textAlign="right">
                <Box component="span">
                  <Button
                    className={classes.closeDrawer}
                    onClick={() => {
                      closeDrawer();
                    }}
                  >
                    ×
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}
